/*
 * (c) Copyright, 2025, Medidata Solutions Worldwide, Inc. All rights reserved.
 */

import { useState } from 'react'
import { useTranslation } from 'react-i18next'
import { Formik } from 'formik'
import Modal from '../Modal'
import { ErrorMessageStyled } from '../shared/ErrorMessage'

/**
 * Modal for adding custom justification text
 * Ported from lego/page/browser/add-document/AddCustomJustificationModal.jsx
 */

interface AddCustomJustificationModalProps {
  request: any
  setRequest: (updater: (prev: any) => any) => void
  setShowAddCustomModal: (show: boolean) => void
}

export const AddCustomJustificationModal: React.FC<AddCustomJustificationModalProps> = ({
  request,
  setRequest,
  setShowAddCustomModal
}) => {
  const { t: translate } = useTranslation()
  const [isOpen, setIsOpen] = useState(true)

  const doClose = () => {
    setIsOpen(false)
    setShowAddCustomModal(false)
  }

  return (
    <Modal show={isOpen} handleClose={doClose} title={translate('WORKFLOW_CUSTOM_JUSTIFICATION_DESC')}>
      <Formik
        initialValues={{ customJustificationText: request.customJustificationText || '' }}
        enableReinitialize
        onSubmit={(values) => {
          if (values.customJustificationText && values.customJustificationText.length !== 0) {
            setRequest((prev: any) => ({
              ...prev,
              customJustificationText: values.customJustificationText
            }))
          }
          doClose()
        }}
      >
        {({ handleSubmit, values, handleChange }) => (
          <>
            <Modal.Body>
              <div className="form-group">
                <label htmlFor="f1db725e-91c7-4629-8568-f09436af9f31">{translate('DESCRIPTION')}</label>
                <input
                  type="text"
                  name="customJustificationText"
                  maxLength={10240}
                  id="f1db725e-91c7-4629-8568-f09436af9f31"
                  className="form-control"
                  value={values.customJustificationText}
                  onChange={handleChange}
                />
                <ErrorMessageStyled name="customJustificationText" />
              </div>
            </Modal.Body>
            <Modal.Footer>
              <button
                data-action="save"
                className="btn btn-primary text-capitalize"
                onClick={() => handleSubmit()}
                id="3c8c2e21-00e8-4620-b459-a2513dcf500d"
                type="button"
              >
                {translate('OK')}
              </button>
            </Modal.Footer>
          </>
        )}
      </Formik>
    </Modal>
  )
}

export default AddCustomJustificationModal
